import * as React from 'react'
import { Link } from 'react-router-dom'
import { UserIsStaffContext } from '../App'
import { Admin } from './Admin'
import { Connect } from './Connect'
import { Logout } from './Logout'

//This component display different items of the menu.
export const Menu: React.FunctionComponent = (props) => {

    const [isConnected, setIsConnected] = React.useState(false)
    const {currentUserIsStaff, setCurrentUserIsStaff} = React.useContext(UserIsStaffContext)

    
    const isAdmin = () => {
        if(currentUserIsStaff) {
            return(
                <div className="MenuItem"><Link to = "/admin"><Admin></Admin></Link></div>
            )
        }
    }

    return(
        <div className="MenuFlexBox">
            <div className="MenuSubFlexBoxLeft">
            <a href="https://en-deuil-et.com/" className="MenuItem">Accueil</a>
            <a href="https://en-deuil-et.com/index.php?pages/A-propos" className="MenuItem">Qui suis-je ?</a>
            <a href="https://en-deuil-et.com/index.php?contact" className="MenuItem">Contact</a>
            <div className="MenuItem"><Link to = "/">E-Formations</Link></div>
            </div>
            <div className="MenuSubFlexBoxRight">
            <div className="MenuItem"><Connect isConnected={isConnected} setIsConnected={setIsConnected}></Connect></div>
            {isAdmin()}
            <div className="MenuItem"><Logout isConnected={isConnected} setIsConnected={setIsConnected}></Logout></div>
            </div>
        </div>
    )
}